import React from "react";
import { Buttons } from "@danishagro/cms/src/components/Buttons/Buttons.component";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Icon } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { ImageViewer } from "@danishagro/cms/src/components/ImageViewer/ImageViewer.component";
import { useDropdownImageSize } from "src/blocks/hooks/useDropdownImageSize/useDropdownImageSize.hook";
import { DA_BasicLinkWrapper } from "./components/BasicLinkWrapper.component";
import { SpotProps } from "./Spot.interface";
import { useAlignment } from "./hooks/useAlignment.hook";
import S from "./Spot.module.scss";

const Spot = (props: SpotProps) => {
    const { alignmentClass } = useAlignment(props.alignment, S);
    const { imageDropdownSizeClass } = useDropdownImageSize(props?.image?.dropdownImageSize, S);

    return (
        <div className={cn(S.wrapper, alignmentClass)}>
            {/** Image */}
            {props.image ? (
                <DA_BasicLinkWrapper
                    href={props.link?.url}
                    target={props.link?.target}
                    className={cn(S.link, S.imageWrapper, imageDropdownSizeClass)}
                >
                    <ImageViewer
                        src={props.image.url}
                        className={S.image}
                        aspectRatioY={props.ignoreHeight ? undefined : 200}
                        aspectRatioX={props.ignoreHeight ? undefined : 300}
                        alternative={props.image.alternative}
                    />
                </DA_BasicLinkWrapper>
            ) : null}

            {/** Icon */}
            {!props.image && props.icon ? (
                <DA_BasicLinkWrapper
                    href={props.link?.url}
                    target={props.link?.target}
                    className={S.link}
                >
                    <DA_Icon name={props.icon} className={S.icon} />
                </DA_BasicLinkWrapper>
            ) : null}

            {/** Headline */}
            {props.headline ? (
                <DA_BasicLinkWrapper
                    href={props.link?.url}
                    target={props.link?.target}
                    className={S.link}
                >
                    <DA_Title h3 tag={DA_TitleTag.H3} noMargin fullWidth className={S.headline}>
                        {props.headline}
                    </DA_Title>
                </DA_BasicLinkWrapper>
            ) : null}

            {/** Text */}
            {props.text ? (
                <DA_BasicLinkWrapper
                    href={props.link?.url}
                    target={props.link?.target}
                    className={cn(S.link, S.textWrapper)}
                >
                    <DA_Text html={props.text} noPadding />
                </DA_BasicLinkWrapper>
            ) : null}

            {/** Buttons */}
            <Buttons buttons={props.buttons} theme={props.alternativeButtonTheme} />
        </div>
    );
};

export default Spot;
